<template>
  <div class="description-block">
    <div class="description-heading">
      <span>Описание / комментарий</span>
      <a-button
        v-if="editable && !editing"
        type="link"
        size="small"
        title="Редактировать"
        aria-label="Редактировать"
        @click="start">
        <edit-outlined />
      </a-button>
    </div>
    <template v-if="editing">
      <a-textarea
        v-model:value="draft"
        :rows="3"
        :maxlength="5000"
        show-count />
      <div class="description-actions">
        <a-button
          size="small"
          :disabled="saving"
          @click="editing = false">
          Отменить
        </a-button>
        <a-button
          size="small"
          type="primary"
          :loading="saving"
          @click="save">
          Сохранить
        </a-button>
      </div>
    </template>
    <p
      v-else
      class="description-text">
      {{ version.comment || 'Описание не добавлено' }}
    </p>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { EditOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { httpClient } from '@/httpClient';

const props = defineProps({
  version: { type: Object, required: true },
  editable: Boolean,
  styleId: { type: [String, Number], default: null },
  endpoint: { type: String, default: null },
});
const emit = defineEmits(['updated']);
const editing = ref(false);
const saving = ref(false);
const draft = ref('');
const start = () => { draft.value = props.version.comment || ''; editing.value = true; };
const save = async () => {
  saving.value = true;
  try {
    const comment = draft.value.trim() || null;
    await httpClient.patch(
      props.endpoint || `/api/crm/apartments/styles/${props.styleId}/object_versions/${props.version.id}`,
      { comment },
    );
    emit('updated', { id: props.version.id, comment });
    editing.value = false;
    message.success('Описание сохранено');
  } catch (error) {
    message.error(error.response?.data?.message || 'Не удалось сохранить описание');
  } finally { saving.value = false; }
};
</script>
<style scoped>
.description-heading {
  display: flex; align-items: center; gap: 12px; color: #8c8c8c; font-size: 13px; margin-bottom: 6px;
}
.description-text { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere; }
.description-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 22px; }
</style>
